import { BaseEntity } from '@/actions/dtos/baseEntity';

export interface Document extends BaseEntity {
  name: string;
  type: string;
  size: number;
  path?: string;
  category?: DocumentCategory;
  parts?: number;
  summary?: string;
}

export enum DocumentCategory {
  INVITATION_AND_OVERVIEW = 'Ausschreibung',
  INSTRUCTIONS_AND_GUIDELINES = 'Richtlinien',
  LEGAL_AND_CONTRACTUAL = 'Vertragliches',
  TECHNICAL_AND_SCOPE = 'Leistungsumfang',
  FINANCIAL_AND_COMMERCIAL = 'Finanzielles',
  ADMINISTRATIVE_AND_SUPPORTING = 'Verwaltung',
  POST_TENDER_AND_AWARD_RELATED = 'Vergabe',
}
